/**
 * Web update check (M57). Each build stamps the app with a build ID and writes the same ID to
 * /version.json. The app reads that file now and then (every 10 minutes and whenever the tab comes
 * back into view) and says when a newer build is deployed; it never reloads by itself. A check that
 * fails (offline, server busy) changes nothing and is tried again at the next chance.
 */
declare const __MIRAOPS_BUILD__: string;
export const CURRENT_BUILD: string = typeof __MIRAOPS_BUILD__ === 'string' ? __MIRAOPS_BUILD__ : 'dev';
export const CHECK_EVERY_MS = 10 * 60 * 1000;

/** The deployed build ID from a version.json body, or null when the body isn't one. */
export function deployedBuild(body: unknown): string | null {
  const build = body && typeof body === 'object' ? (body as { build?: unknown }).build : null;
  return typeof build === 'string' && /^[A-Za-z0-9._-]{1,64}$/.test(build) ? build : null;
}

/** True when the server has a different build than the one running here. */
export async function newerBuildDeployed(load: (url: string, init: RequestInit) => Promise<Response> = fetch): Promise<boolean> {
  try {
    const response = await load('/version.json', { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) return false;
    const build = deployedBuild(await response.json());
    return build !== null && build !== CURRENT_BUILD;
  } catch { /* ignored: offline or unreadable: checked again at the next interval */ 
    return false; // Offline or unreadable: retried at the next check.
  }
}
